import { utils } from '@ps/poker-games-tile-mappers';
import React from 'react';
import { useIntl } from 'react-intl';

import type { InfoItemProps } from '../../InfoItem/InfoItem';
import type { InfoItemsProps } from '../InfoItemsContainer';
import InfoItemsList from '../InfoItemsList';
import {
  getPrizePoolFirstPrizeItem,
  getPrizePoolItem,
  getStartingChipsItem,
  getTimeItemStartsIn,
  hasStartTime
} from '../utils';

const InfoItemsSeating: React.FC<InfoItemsProps> = ({ tournament, timesData }) => {
  const intl = useIntl();
  const isPrizeRealMoney = utils.mttUtils.isPrizePoolRealMoney(tournament.prizePoolUnit);

  const infoItems: InfoItemProps[] = [];
  if (hasStartTime(tournament)) {
    infoItems.push(getTimeItemStartsIn(timesData, intl));
  }
  if (isPrizeRealMoney) {
    infoItems.push(getPrizePoolFirstPrizeItem(tournament, intl));
  } else {
    infoItems.push(getPrizePoolItem(tournament));
  }
  infoItems.push(getStartingChipsItem(tournament, intl));

  return <InfoItemsList infoItems={infoItems} />;
};

export default InfoItemsSeating;
